import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function apiUpdateSavedConfigName(configCode: string, name: string, comment: string): Promise<boolean> {
  return occFetch(occUrl(`/saved-configs/${configCode}`), {
    body: JSON.stringify({ name, comment }),
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
  })
    .then((result) => {
      if (result.ok) {
        return true;
      } else {
        console.error(`Error sending linear update: ${result.status}`);
        return false;
      }
    })
    .catch((err) => {
      console.error(err);
      return false;
    });
}
